import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('PrincipalBuyer', PrincipalBuyerData);

    /* @ngInject */
    function PrincipalBuyerData(UtilSvc, PRINCIPAL) {
        PrincipalBuyer.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            prepareForServer: prepareForServer,
            isEditable: isEditable,
        };

        function PrincipalBuyer(principalBuyerData) {
            if (!principalBuyerData) {
                this.buildEmpty();
            } else {
                this.build(principalBuyerData);
            }
        }

        return PrincipalBuyer;

        /////////////////////

        function buildEmpty() {
            this.paramBuyer = false;
            this.initParamBuyer = this.paramBuyer;
            this.invitationType = PRINCIPAL.invitationType[0];
            this.emailTemplateType = PRINCIPAL.emailTemplateType[0];
            this.buyerInscriptionMaxRemind = 3;
            this.buyerInscriptionRemindInterval = 10;
            this.mailReport = null;
            this.reportRegistrationFrequency = PRINCIPAL.reportFrequencies[1]; // WEEKLY
            this.invitationReportErrorFrequency = PRINCIPAL.invitationReportErrorFrequencies[1]; // WEEKLY
            this.buyerReportRemindersFrequency = PRINCIPAL.reportFrequencies[3];// NEVER
            this.reportRelationshipFrequency = PRINCIPAL.reportFrequencies[3];// NEVER
            this.reportIntegrationFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.hasBuyer = null;
            this.hasInvoicesBuyer = true;
            this.hasOrdersBuyer = false;
            this.hasDocumentarySpace = false;
            this.hasBuyerBillingFlow = false;
            this.transmissionModeMail = false;
            this.transmissionModeFtp = false;
        }

        function build(principalBuyerData) {
            this.paramBuyer = true;
            this.initParamBuyer = this.paramBuyer;
            this.invitationType = principalBuyerData.invitationType || PRINCIPAL.invitationType[0];
            this.emailTemplateType = principalBuyerData.emailTemplateType || PRINCIPAL.emailTemplateType[0];
            this.buyerInscriptionMaxRemind = principalBuyerData.buyerInscriptionMaxRemind || 3;
            this.buyerInscriptionRemindInterval = principalBuyerData.buyerInscriptionRemindInterval || 10;
            this.mailReport = UtilSvc.splitMail(principalBuyerData.mailReport);
            this.reportRegistrationFrequency =
                principalBuyerData.reportRegistrationFrequency || PRINCIPAL.reportFrequencies[1];
            this.invitationReportErrorFrequency =
                principalBuyerData.invitationReportErrorFrequency || PRINCIPAL.invitationReportErrorFrequencies[1];
                this.reportIntegrationFrequency =
                principalBuyerData.reportIntegrationFrequency || PRINCIPAL.reportFrequencies[3];
                this.reportRelationshipFrequency =
                principalBuyerData.reportRelationshipFrequency || PRINCIPAL.reportFrequencies[3];
            this.hasBuyer = principalBuyerData.hasBuyer || null;
            this.hasInvoicesBuyer = principalBuyerData.hasInvoicesBuyer;
            this.hasOrdersBuyer = principalBuyerData.hasOrdersBuyer;
            this.hasDocumentarySpace = principalBuyerData.hasDocumentarySpace;
            this.hasBuyerBillingFlow = principalBuyerData.hasBuyerBillingFlow || false;
            this.transmissionModeMail = principalBuyerData.transmissionModeMail;
            this.transmissionModeFtp =
                (!principalBuyerData.transmissionModeFtp && !principalBuyerData.transmissionModeMail) ||
                principalBuyerData.transmissionModeFtp;
            this.buyerReportRemindersFrequency =
                principalBuyerData.buyerReportRemindersFrequency || PRINCIPAL.reportFrequencies[3];
            this.paymentEnabled = principalBuyerData.paymentEnabled;
        }

        function prepareForServer() {
            this.mailReport = UtilSvc.joinMail(this.mailReport);
        }

        function isEditable() {
            if (this.hasBuyer === null) {
                return true;
            } else if (this.hasBuyer === false) {
                return true;
            } else if (this.hasBuyer === true && this.initParamBuyer === false) {
                return true;
            }
            return false;
        }
    }
})();
